import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as VueGoogleMaps from 'vue2-google-maps'
import smsCode from 'vue-sms-codes'
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar)
Vue.use(smsCode)
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDvpz-TIAtBUFGJhL3nF7FELUGam8oysXA',
    libraries: 'places', 
  },
  installComponents: true
})
